import React from "react";

import svg from "../../assets/images/icons/Form Controls/line.svg";

export const LineIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Line"}
    />
);
